import React from 'react';
import { Flexbox, SimpleFlexbox } from 'ctm-components';

/**
 * Given an element schema and layout components, create the appropriate html element wrappers with component children
 */
class LayoutFactory {

    /**
     * @desc simple factory method to create Flexbox component with given props and children
     * @param {String} layoutSchemaName - the name of the schema, e.g. 'container_centered_header'
     * @param {Object} schemaLayoutProps - props to render flexbox
     * @param {Array} children - children components
     * @returns {Node} Flexbox component
     */
    createLayoutComponent = (layoutSchemaName, schemaLayoutProps, children) => {
        // If there aren't any children, i.e. perhaps we aren't using a layoutAreaKey in a particular schema, then return null.
        if (!children.length) {
            return null;
        }

        // @todo: remove this once confirm no schema is using visualProps and elementProps
        const { elementProps, visualProps, ...otherProps } = schemaLayoutProps;

        // For Layouts with Rules use Redux Store connected Flexbox
        const component = schemaLayoutProps.rules ? Flexbox : SimpleFlexbox;

        const layoutProps = { key: layoutSchemaName, ...elementProps, ...visualProps, ...otherProps };

        return React.createElement(component, layoutProps, ...children);
    };

}

export { LayoutFactory };
